import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import CurrencyMethods from "../../../../../admin/API/currencyMethods";

//STYLES
import * as OrderDetailsItemStyles from "../../styles/orderDetailsItem";

function OrderDetailsRepaidItem(props) {
    const [remainingPrice, setRemainingPrice] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        setRemainingPrice(parseInt(props.item.fullPriceWhenOrdered) - props.item.depositPriceWhenOrdered);
    }, []);

    function handleGoToOriginalOrder() {
        console.log(props.item.originalOrderID);
        navigate(`../orderDetails/${props.item.originalOrderID}`);
    }

    return (
        <div>
            <div style={OrderDetailsItemStyles.body}>
                <Row onClick={handleGoToOriginalOrder}>
                    <Col>{props.item.itemDetails.title} (remaining amount)</Col>
                    <Col>Click here to see the original order of this item</Col>
                    <Col sm={"auto"} style={OrderDetailsItemStyles.repaidItem_columnRight}>
                        £{CurrencyMethods.FormatCurrency(remainingPrice)}
                    </Col>
                </Row>
            </div>
            <br />
        </div>
    );
}

export default OrderDetailsRepaidItem;
